import { theme } from "../../../layout/Theme";

export const sectionPaperSx = {
  p: 3,
  border: `solid 1px ${theme.palette.neutral[200]}`,
  borderRadius: 2,
};

export const compactPaperSx = {
  p: 2,
  border: `solid 1px ${theme.palette.neutral[200]}`,
  borderRadius: 2,
};

export const fieldLabelSx = {
  color: theme.palette.neutral[600],
  fontSize: 14,
  fontWeight: 600,
  fontFamily: ["Open Sans", "sans-serif"].join(","),
  "&.Mui-focused": { color: theme.palette.neutral[600] },
};
